import { LinkPlusIcon } from './LinkPlusIcon';

/**
 * author: Google
 * id 0436D77E-F53E-4A1E-A402-916D7D90A1BE
 * name link-plus
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/link-plus.svg
 * tags
 */
export const LinkAddIcon = LinkPlusIcon;
export default LinkAddIcon